<template>
  <router-view />
</template>

<script>
export default {
  name: 'Expenses'
};
</script>

<style lang="scss" scoped></style>
